import React, { useEffect, useState } from "react";
import { Table, Form, Card, Row, Col, Spinner, Modal } from "react-bootstrap";
import "../../../../style/addrestoration.css";
import "../../../../style/addmaterial.css";

import { toast } from "react-toastify";
import { apiAxios } from "../../../../utils/apiAxios";


const API_URL = `${process.env.REACT_APP_API_BASE_URL}/Shade`;

const AddShade: React.FC = () => {
  const [shadeName, setShadeName] = useState("");
  const [shades, setShades] = useState<{ shadeID: number; name: string }[]>([]);
  const [editId, setEditId] = useState<number | null>(null);
  const [editValue, setEditValue] = useState("");
  const [loading, setLoading] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  const fetchShades = async () => {
    try {
      setLoading(true);
      const res = await apiAxios.get(`${API_URL}/GetAll`);
      if (res.data.isSuccess) {
        const shades = res.data.data || res.data.singleData || [];
        setShades(shades);
      } else {
        toast.warn("Failed to fetch shades");
      }
    } catch (error) {
      console.error("Error fetching shades:", error);
      toast.error("Error fetching shades");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchShades();
  }, []);

const handleAdd = async () => {
  if (!shadeName.trim()) {
    toast.warn("Please enter shade name");
    return;
  }

  const isDuplicate = shades.some(
    (s) => s.name.toLowerCase() === shadeName.trim().toLowerCase()
  );

  if (isDuplicate) {
    toast.error("Shade with this name already exists");
    return;
  }

  try {
    setLoading(true);

    const { data } = await apiAxios.post(`${API_URL}/Create`, {
      name: shadeName.trim(),
    });

    if (data?.isSuccess) {
      setShades((prev) => [...prev, data.singleData]);
      setShadeName("");
      toast.success("Shade added successfully");
    } else {
      toast.error(data?.status || "Failed to add shade");
    }
  } catch (error: any) {
    console.error("Error adding shade:", error);

    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Error adding shade";

    toast.error(message);
  } finally {
    setLoading(false);
  }
};

  const confirmDelete = (id: number) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

const handleDelete = async () => {
  if (deleteId === null) return;

  try {
    setLoading(true);

    const { data } = await apiAxios.delete(
      `${API_URL}/Delete/${deleteId}`
    );

    if (data?.isSuccess) {
      setShades((prev) =>
        prev.filter((item) => item.shadeID !== deleteId)
      );
      toast.success("Shade deleted successfully");
    } else {
      toast.error(data?.status || "Failed to delete shade");
    }
  } catch (error: any) {
    console.error("Error deleting shade:", error);

    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Error deleting shade";

    toast.error(message);
  } finally {
    setLoading(false);
    setShowDeleteModal(false);
    setDeleteId(null);
  }
};

  const handleEdit = (id: number, name: string) => {
    setEditId(id);
    setEditValue(name);
  };

const handleUpdate = async () => {
  if (!editValue.trim() || editId === null) {
    toast.warn("Please enter shade name");
    return;
  }

  const isDuplicate = shades.some(
    (s) =>
      s.name.toLowerCase() === editValue.trim().toLowerCase() &&
      s.shadeID !== editId
  );

  if (isDuplicate) {
    toast.error("Another shade with this name already exists");
    return;
  }

  try {
    setLoading(true);

    const { data } = await apiAxios.put(`${API_URL}/Update`, {
      shadeID: editId,
      name: editValue.trim(),
    });

    if (data?.isSuccess) {
      setShades((prev) =>
        prev.map((item) =>
          item.shadeID === editId
            ? { ...item, name: editValue.trim() }
            : item
        )
      );

      setEditId(null);
      setEditValue("");
      toast.success("Shade updated successfully");
    } else {
      toast.error(data?.status || "Failed to update shade");
    }
  } catch (error: any) {
    console.error("Error updating shade:", error);

    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Error updating shade";

    toast.error(message);
  } finally {
    setLoading(false);
  }
};
  const handleCancel = () => {
    setEditId(null);
    setEditValue("");

  };

  return (
    <div className="">
      <h4 className="mb-4"> Add Shade</h4>
      <div className="premium-card p-4">
        <label className="form-label">Add New Shade</label>

        <Row className="mb-2">
          <Col>
            <Form.Control
              type="text"
              placeholder="Enter Shade"
              value={shadeName}
              onChange={(e) => setShadeName(e.target.value)}
            />
          </Col>
        </Row>

        <Row>
          <Col className="text-start mt-3">
            <button type="submit" className="btn py-2 px-3 btn-primary" onClick={handleAdd}>Add Shade</button>

          </Col>
        </Row>

      </div>
      <div className="premium-card rounded p-4 mt-5">

       <h5 className="mb-3">Shade List</h5>

        {loading ? (
          <div className="text-center p-3">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <Table bordered responsive className="align-middle  addshade-table mb-0 custom-material-table">
            <thead>
              <tr>
                <th style={{ width: "80px" }}>Sr No</th>
                <th>Shade</th>
                <th style={{ width: "250px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {shades.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-center text-muted">
                    No Shade added yet
                  </td>
                </tr>
              ) : (
                shades.map((item, index) => (
                  <tr key={item.shadeID}>
                    <td>{index + 1}</td>
                    <td>
                      {editId === item.shadeID ? (
                        <Form.Control
                          type="text"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                        />
                      ) : (
                        <span className="fw-semibold">{item.name}</span>
                      )}
                    </td>
                    <td>
                      {editId === item.shadeID ? (
                        <div className="d-flex justify-content-center gap-2">
                          <div



                            className="action-btn delete custom-edit-icon"


                            onClick={handleUpdate}

                          >
                            <i className="bi bi-check-lg" title="Update"></i>
                          </div>
                          <div



                            className="action-btn delete custom-edit-icon"

                            onClick={handleCancel}
                          >
                            <i className="bi bi-x-lg" title="Cancel"></i>
                          </div>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center gap-2">
                          <div



                            className="action-btn delete custom-edit-icon"



                            onClick={() => handleEdit(item.shadeID, item.name)}
                          >
                            <i className="bi bi-pencil-square" title="Edit"></i>
                          </div>
                          <div



                            className="action-btn delete custom-edit-icon"


                            onClick={() => confirmDelete(item.shadeID)}
                          >
                            <i className="bi bi-trash" title="Delete"></i>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}

      </div>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} >
        <Modal.Body className="text-center">
          Are you sure you want to delete this shade?
        </Modal.Body>

        <Modal.Footer className="d-flex modal-footer-section justify-content-center">
          <button type="button" className="btn py-2 px-3 btn-primary" onClick={handleDelete}>

            Yes
          </button>
          <button type="button" onClick={() => setShowDeleteModal(false)} className="btn py-2 px-3 btn-secondary mx-2">No</button>

          {/* <AppButton variant="secondary"  className="mx-2">
      No
    </AppButton> */}
        </Modal.Footer>
      </Modal>


    </div>
  );
};

export default AddShade;
